/* global MutationObserver */

export default function initStyleQuiz () {
  const form = document.getElementById('vjs-stylequiz-form')
  if (!form) return

  onClickTile()
  onClickNext()
  onClickBack()
  onClickSkip()
  onClickSubmit()
}

function onClickTile () {
  const tiles = Array.from(document.querySelectorAll('.vjs-stylequiz-listing-tile'))
  tiles.forEach(tile => {
    tile.addEventListener('click', () => {
      toggleTileSelection(tile)
    })
  })
}

function onClickNext () {
  const nextBtns = Array.from(document.querySelectorAll('.vjs-stylequiz__next-btn'))
  nextBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      saveProgressAndAdvance()
    })
  })
}

function onClickBack () {
  const backBtns = Array.from(document.querySelectorAll('.vjs-stylequiz__back-btn'))
  backBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      goToPreviousRound()
    })
  })
}

function onClickSkip () {
  const skipLinks = Array.from(document.querySelectorAll('.vjs-stylequiz__skip-round-link'))
  skipLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault()
      saveProgressAndAdvance()
    })
  })
}

function onClickSubmit () {
  const submitBtn = document.querySelector('.vjs-stylequiz__submit-btn')
  if (!submitBtn) return

  submitBtn.addEventListener('click', (e) => {
    e.preventDefault()
    submitQuiz()
  })
}

function toggleTileSelection (tile) {
  const listingId = parseInt(tile.dataset.listingId)
  const isSelected = tile.classList.contains('vsd-stylequiz-selected')
  const selectionIndicator = tile.querySelector('.vjs-stylequiz-selection-indicator')
  const checkmark = tile.querySelector('.vjs-stylequiz-checkmark')

  if (isSelected) {
    deselectTile(tile, selectionIndicator, checkmark, listingId)
  } else {
    selectTile(tile, selectionIndicator, checkmark, listingId)
  }

  updateListingIdsField()
}

function selectTile (tile, selectionIndicator, checkmark, listingId) {
  tile.classList.add('vsd-stylequiz-selected', 'vsd-stylequiz-listing-tile-selected')
  selectionIndicator.classList.add('vsd-stylequiz-selection-indicator-selected')
  checkmark.classList.remove('hidden')

  const selectedIds = getSelectedListingIds()
  selectedIds.push(listingId)
  setSelectedListingIds(selectedIds)
}

function deselectTile (tile, selectionIndicator, checkmark, listingId) {
  tile.classList.remove('vsd-stylequiz-selected', 'vsd-stylequiz-listing-tile-selected')
  selectionIndicator.classList.remove('vsd-stylequiz-selection-indicator-selected')
  checkmark.classList.add('hidden')

  const selectedIds = getSelectedListingIds()
  const updatedIds = selectedIds.filter(id => id !== listingId)
  setSelectedListingIds(updatedIds)
}

function getSelectedListingIds () {
  const field = document.getElementById('vjs-listing-ids-field')
  const value = field.value.trim()
  return value ? value.split(',').map(id => parseInt(id)) : []
}

function setSelectedListingIds (ids) {
  document.getElementById('vjs-listing-ids-field').value = ids.join(',')
}

function updateListingIdsField () {
  const selectedIds = getSelectedListingIds()
  setSelectedListingIds(selectedIds)
}

function getCurrentRound () {
  return parseInt(document.getElementById('vjs-current-round-field').value)
}

function getTotalRounds () {
  return document.querySelectorAll('[data-round]').length
}

function showRound (roundNumber) {
  const allRounds = Array.from(document.querySelectorAll('[data-round]'))
  allRounds.forEach((round, index) => {
    if (index === roundNumber) {
      round.classList.remove('hidden')
    } else {
      round.classList.add('hidden')
    }
  })

  document.getElementById('vjs-current-round-field').value = roundNumber
  window.scrollTo(0, 0)
}

function saveProgressAndAdvance () {
  const currentRound = getCurrentRound()
  const totalRounds = getTotalRounds()

  if (currentRound < totalRounds - 1) {
    saveProgress(() => {
      showRound(currentRound + 1)
    })
  }
}

function goToPreviousRound () {
  const currentRound = getCurrentRound()

  if (currentRound > 0) {
    showRound(currentRound - 1)
  }
}

function saveProgress (callback) {
  const selectedIds = getSelectedListingIds()
  const currentRound = getCurrentRound()
  const formData = new FormData()

  selectedIds.forEach(id => {
    formData.append('listing_ids[]', id)
  })

  formData.append('current_round', currentRound + 1)

  window.fetch('/stylequiz', {
    method: 'PUT',
    body: formData,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
    }
  }).then(response => {
    if (response.ok) {
      if (callback) callback()
    } else {
      console.error('Failed to save progress')
    }
  }).catch(error => {
    console.error('Error saving progress:', error)
  })
}

function submitQuiz () {
  const loadingModal = document.getElementById('vjs-stylequiz-loading-modal')
  loadingModal.classList.add('show')

  const selectedIds = getSelectedListingIds()
  const formData = new FormData()
  selectedIds.forEach(id => {
    formData.append('listing_ids[]', id)
  })
  formData.append('submit_quiz', 'true')

  window.fetch('/stylequiz', {
    method: 'PUT',
    body: formData,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
    }
  }).catch(error => {
    console.error('Error submitting quiz:', error)
  })

  // Watch for Turbo Stream broadcast that replaces the modal content with the success state
  const observer = new MutationObserver(() => {
    const redirectLink = document.querySelector('[data-stylequiz-redirect]')
    if (redirectLink) {
      observer.disconnect()
      // Brief pause so the user sees the success message before redirect
      setTimeout(() => {
        window.location.href = redirectLink.dataset.stylequizRedirect
      }, 1500)
    }
  })
  observer.observe(loadingModal, { childList: true, subtree: true })
}
